/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterOrigin_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuMultiSelectSearch_itemSearch">;
    readonly " $refType": "SbSharedRefineMenuFilterOrigin_itemSearch";
};
export type SbSharedRefineMenuFilterOrigin_itemSearch$data = SbSharedRefineMenuFilterOrigin_itemSearch;
export type SbSharedRefineMenuFilterOrigin_itemSearch$key = {
    readonly " $data"?: SbSharedRefineMenuFilterOrigin_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterOrigin_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuFilterOrigin_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectSearch_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = 'df1a710fcc76821d0e1411806d6d7fc1';
export default node;
